export const ApiAuth = {
  Login: 'auth/login',
  RefreshLogin: 'auth/refresh',
  Users: 'auth/users',
  Alive: 'auth/alive',
};

export const GridApi = {
  Agent: 'agent/load',
  Customer: 'customer/load',
  CustomerAgentAssignment: 'customerAgentAssignment/load',
  Supplier: 'supplier/load',
  Product: 'product/load',
  Company: 'company/load',
  Contract: 'contract/load',
  Category: 'category/load',
  Job: 'job/load',
  Transaction: 'transaction/load',
}

export const Api = {
  Agent: 'api/agent',
  Agents: 'api/agent/agents',
  Media: 'api/media',
  MediaAchive: 'api/media/archive',
  Job: 'api/job',
  JobImportInvoice: 'api/job/invoice',
  ReprocessAll: 'api/job/reprocess/all', 
  DeleteAll: 'api/job/delete/all',
  DeleteImport: 'api/job/delete/import',
  SyncFic: 'api/hook/fic/import-entity',
  Company: 'api/company',
  Contract: 'api/contract',
  Contracts: 'api/contract/contracts',
  ContractsCustomer: 'api/contract/customer',
  Companies: 'api/company/companies',
  Category: 'api/category',
  Categories: 'api/category/categories',
  CategoriesImport: 'api/category/import-list',
  CategoryMapping: 'api/category/mapping',
  CustomerAgentAssignment: 'api/customerAgentAssignment',
  CustomerAgentAssignments: 'api/customerAgentAssignment/all',
  Customer: 'api/customer',
   Customers: 'api/customer/customers',
   
  CustomerAddress: 'api/customerAddress',
  CustomerAddresses: 'api/customerAddress/customerAddresses',
 
  CustomerPref: 'api/customer/pref',
  Referral: 'api/referral',
  Product: 'api/product',
  Negotiation: 'api/negotiation',
  Negotiations: 'api/negotiation/negotiations',
  Products: 'api/product/products',
  ReportCustomers: 'api/report/customers',
  ReportCustomer: 'api/report/customer',
  ReportCustomerProduct: 'api/report/customer-product',
  ReportContractYears: 'api/report/contract-years',
  ReportContractCategories: 'api/report/contract-categories',
  Supplier: 'api/supplier',
  Suppliers: 'api/supplier/suppliers',
  Transaction: 'api/transaction',
  Transactions: 'api/transaction/transactions',
  TransactionsContract: 'api/transaction/transactions/contract',
};
